export default "__VITE_ASSET__BeNIK5v$__"